import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer id='footer' className='footer'>
            <div className='container footer-top'>
                <div className='row gy-4 d-flex justify-content-center justify-content-md-between'>
                    <div className='col-md-4 footer-about text-center text-md-start'>
                        <Link to='/' className='text-center'>
                            <img src={'/img/logo_yellow.webp'} loading='lazy' alt='Logo Glami Inside Fashion' width='120px' />
                        </Link>
                        <div className='footer-contact pt-3'>
                            <p>
                                <strong>P.Iva: </strong>
                                <span>17200871006</span>
                            </p>
                            <p>
                                <strong>Telefono: </strong>
                                <span>
                                    <a href='tel:+393792601719'>+39 379 260 1719</a>
                                </span>
                            </p>
                            <p>
                                <strong>Email: </strong>
                                <span>
                                    <a href='mailto:info@glaminsidefashion.it'>info@glaminsidefashion.it</a>
                                </span>
                            </p>
                        </div>
                    </div>

                    <div className='col-md-4 text-center text-md-start'>
                        <h4 className='pr-md-5'>Seguici su</h4>
                        <div className='social-links d-flex mt-3 justify-content-center justify-content-md-start'>
                            <Link to='https://www.facebook.com/glaminsidefashion' target='_blank' rel='noreferrer'>
                                <i className='bi bi-facebook'></i>
                            </Link>
                            <Link to='https://www.instagram.com/glaminsidefashion' target='_blank' rel='noreferrer'>
                                <i className='bi bi-instagram'></i>
                            </Link>
                            <Link to='https://www.linkedin.com/in/glami-inside-fashion-9a0b45270' target='_blank' rel='noreferrer'>
                                <i className='bi bi-linkedin'></i>
                            </Link>
                        </div>
                        <div className='d-flex mt-3 justify-content-center justify-content-md-start'>
                            <a
                                href='https://www.iubenda.com/privacy-policy/74636372'
                                className='iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe '
                                title='Privacy Policy '
                            >
                                Privacy Policy
                            </a>

                            <a
                                href='https://www.iubenda.com/privacy-policy/74636372/cookie-policy'
                                className='iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe '
                                title='Cookie Policy '
                            >
                                Cookie Policy
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
export default Footer;
